<template>
  <el-container class="main_container">
    <el-main>
      <div class="DataModule full_height">
        <router-view></router-view>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  methods: {
    ...mapMutations(["setMobileStatus","changeIndexShow"])
  }
};
</script>

<style scoped></style>
